import React from 'react'
import UserAccount from '../wizard-pass/user-account'

const Register = () => {
  return (
    // <div className="jumbotron border-0">
    //     <div className="container">
    //       <h1 className="h2">ثبت نام کاربر</h1>
    //       <UserAccount />
    //     </div>
    // </div> 
    <UserAccount />

  )
}

export default Register